import { FieldErrors, UseFormRegister } from 'react-hook-form';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack } from '@mui/material';

import { TextFieldWithHelperSpace } from '@components/TextFieldWithHelperSpace';

import { generalPredefinedPromptsTexts } from '../../../constants';
import type { FormValues } from '../GeneralPredefinedPrompts';

interface AccordionTitleProps {
    groupIndex: number;
    errors: FieldErrors<FormValues>;
    isSending: boolean;
    register: UseFormRegister<FormValues>;
}

export const AccordionTitle = ({
    groupIndex,
    errors,
    isSending,
    register,
}: AccordionTitleProps) => {
    const titleError = errors.groups?.[groupIndex]?.group;
    const hasPromptsValidationErrors = Boolean(errors.groups?.[groupIndex]?.prompts?.length);
    const hasValidationErrors = Boolean(titleError) || hasPromptsValidationErrors;

    return (
        <Stack direction='row' alignItems='center' gap={1} sx={{ width: '90%' }}>
            <TextFieldWithHelperSpace
                label={generalPredefinedPromptsTexts.groupInputTitle}
                disabled={isSending}
                size='small'
                {...register(`groups.${groupIndex}.group`)}
                fieldError={titleError}
            />
            <ErrorOutlineIcon
                color='error'
                sx={{ visibility: hasValidationErrors ? 'visible' : 'hidden' }}
            />
        </Stack>
    );
};
